/**
 * Created by Holger Szuesz <development@szuesz.de> on 18.07.2018 17:05
 */
 
import * as React from 'react';

import '../styles/Footer.css';

class Footer extends React.Component {
    public render() {
        return (
            <footer className="mastfoot mt-auto">
                <div className="inner">
                    <p>Cover template for <a href="https://getbootstrap.com/">Bootstrap</a>, by <a href="https://twitter.com/mdo">@mdo</a>.</p>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.tsx